import { render, staticRenderFns } from "./NewSyslogModal.vue?vue&type=template&id=804bc2a2&"
import script from "./NewSyslogModal.vue?vue&type=script&lang=js&"
export * from "./NewSyslogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports